// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { NgxLoggerLevel } from 'ngx-logger';

import awsmobile from '../aws-exports-dev';

export const environment = {
  production: false,
  loggerLevel: NgxLoggerLevel.TRACE,
  headerFixed: true,
  dynamicHeaderMenu: true,
  dynamicFooterMenus: false,
  oidc: {
    provider: 'nutanix',
  },
  api: {
    cms: 'https://devapi.motivforcem9.com/cms',
    core: {
      baseUrl: 'https://api-dev.motivforcem9.com/core/api',
      path: {
        member: 'members',
        client: 'clients/nutanix',
      },
    },
  },
  asset: {
    cdn: 'https://nutanix-assets.s3.eu-west-2.amazonaws.com',
  },
  amplify: awsmobile,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
